/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {DrivenEntity} from './entity/driven-entity';
import {Currency} from '../enum/currency.enum';


export abstract class ListGroup<T extends DrivenEntity> {
  public entities: T[] = [];
  public title: string;
  public total: string;
  public currency: Currency;

  protected constructor(entities: T[], title: string) {
    this.title = title;
    for (const ent of entities) {
      this.add(ent);
    }
  }

  /**
   * Add entity to the list of entities and compute total
   * @param entity
   */
  public abstract add(entity: T);
}
